/*
==========================================================
ROMIX PRODUCT PRO v3.3
Archivo: assets/romix-product-pro.js

Cambios principales:
- Precio actual sincronizado con cada variante.
- Precio de comparación tachado.
- Porcentaje de descuento automático.
- Packs Romix con descuentos porcentuales exactos (15 %, 20 %, etc.).
- Conserva el carrito lateral de Shopify.
==========================================================
*/

function initRomixProductPro() {
  console.log('ROMIX PRODUCT PRO v3.3 CARGADO');

  document
    .querySelectorAll('.romix-product-pro')
    .forEach(function (root) {
      if (root.dataset.romixInitialized === 'true') {
        return;
      }

      root.dataset.romixInitialized = 'true';

      initRomixGallery(root);
      initRomixSizeGuide(root);
      initRomixBundles(root);
      initRomixVariantSync(root);
      initRomixAjaxCart(root);
    });
}

/* ==========================================================
   GALERÍA
========================================================== */

function initRomixGallery(root) {
  var thumbs = root.querySelectorAll('[data-rpp-thumb]');
  var thumbStrip = root.querySelector('.rpp-thumbnails');
  var previousButton = root.querySelector('[data-rpp-prev]');
  var nextButton = root.querySelector('[data-rpp-next]');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var imageIndex = thumb.getAttribute('data-rpp-thumb');

      setActiveGalleryImage(root, imageIndex);
    });
  });

  if (previousButton && thumbStrip) {
    previousButton.addEventListener('click', function () {
      thumbStrip.scrollBy({
        left: -120,
        behavior: 'smooth'
      });
    });
  }

  if (nextButton && thumbStrip) {
    nextButton.addEventListener('click', function () {
      thumbStrip.scrollBy({
        left: 120,
        behavior: 'smooth'
      });
    });
  }
}

function setActiveGalleryImage(root, index) {
  root
    .querySelectorAll('[data-rpp-thumb]')
    .forEach(function (item) {
      item.classList.remove('is-active');
    });

  root
    .querySelectorAll('[data-rpp-slide]')
    .forEach(function (item) {
      item.classList.remove('is-active');
    });

  var selectedThumbnail = root.querySelector(
    '[data-rpp-thumb="' + index + '"]'
  );

  var selectedSlide = root.querySelector(
    '[data-rpp-slide="' + index + '"]'
  );

  if (selectedThumbnail) {
    selectedThumbnail.classList.add('is-active');
  }

  if (selectedSlide) {
    selectedSlide.classList.add('is-active');
  }
}

/* ==========================================================
   SINCRONIZACIÓN DE VARIANTES
========================================================== */

function initRomixVariantSync(root) {
  var optionInputs = root.querySelectorAll(
    '.rpp-option-pill input'
  );

  function syncCurrentVariant() {
    var selectedOptions = getRomixSelectedOptions(root);

    var matchedVariant = findRomixVariant(
      root,
      selectedOptions
    );

    if (!matchedVariant) {
      return;
    }

    updateHiddenVariantInput(root, matchedVariant);
    updatePriceFromVariant(root, matchedVariant);
    updateAddToCartState(root, matchedVariant);

    updateGalleryFromVariant(
      root,
      matchedVariant,
      selectedOptions
    );

    refreshBundlePrices(root);
  }

  optionInputs.forEach(function (input) {
    input.addEventListener(
      'change',
      syncCurrentVariant
    );
  });

  syncCurrentVariant();
}

function getRomixSelectedOptions(root) {
  var selectedOptions = [];

  root
    .querySelectorAll('.rpp-option')
    .forEach(function (fieldset) {
      var selectedInput = fieldset.querySelector(
        'input:checked'
      );

      if (selectedInput) {
        selectedOptions.push(selectedInput.value);
      }
    });

  return selectedOptions;
}

/* ==========================================================
   JSON DEL PRODUCTO
========================================================== */

function getProductJson(root) {
  var productJsonScript = root.querySelector(
    'script[type="application/json"][data-rpp-product-json]'
  );

  if (!productJsonScript) {
    productJsonScript = document.querySelector(
      'script[type="application/json"][data-rpp-product-json]'
    );
  }

  if (!productJsonScript) {
    return null;
  }

  try {
    return JSON.parse(productJsonScript.textContent);
  } catch (error) {
    console.error(
      'Romix Product JSON error:',
      error
    );

    return null;
  }
}

function findRomixVariant(root, selectedOptions) {
  var productJson = getProductJson(root);

  if (!productJson || !productJson.variants) {
    return null;
  }

  selectedOptions = (selectedOptions || []).filter(
    function (value) {
      return (
        value !== undefined &&
        value !== null &&
        value !== ''
      );
    }
  );

  return productJson.variants.find(
    function (variant) {
      if (
        !variant.options ||
        variant.options.length !==
          selectedOptions.length
      ) {
        return false;
      }

      return selectedOptions.every(
        function (optionValue, index) {
          var variantOption = String(
            variant.options[index]
          )
            .trim()
            .toLowerCase();

          var selectedOption = String(
            optionValue
          )
            .trim()
            .toLowerCase();

          return variantOption === selectedOption;
        }
      );
    }
  );
}

/* ==========================================================
   CAMPO OCULTO DE VARIANTE
========================================================== */

function updateHiddenVariantInput(root, variant) {
  var formVariantInput = root.querySelector(
    'form[action*="/cart/add"] input[name="id"]'
  );

  if (!formVariantInput || !variant) {
    return;
  }

  formVariantInput.value = variant.id;

  formVariantInput.setAttribute(
    'value',
    variant.id
  );

  formVariantInput.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );
}

/* ==========================================================
   PRECIO ACTUAL, PRECIO TACHADO Y DESCUENTO
========================================================== */

function updatePriceFromVariant(root, variant) {
  if (!root || !variant) {
    return;
  }

  var priceWrapper = root.querySelector(
    '[data-rpp-product-price]'
  );

  var currentPriceElement = root.querySelector(
    '[data-rpp-current-price]'
  );

  var comparePriceElement = root.querySelector(
    '[data-rpp-compare-price]'
  );

  var discountBadge = root.querySelector(
    '[data-rpp-discount-badge]'
  );

  if (!priceWrapper || !currentPriceElement) {
    return;
  }

  var currentPrice = Number(
    variant.price || 0
  );

  var comparePrice = Number(
    variant.compare_at_price || 0
  );

  var hasDiscount =
    comparePrice > currentPrice;

  priceWrapper.setAttribute(
    'data-unit-price',
    currentPrice
  );

  priceWrapper.setAttribute(
    'data-variant-price',
    currentPrice
  );

  priceWrapper.setAttribute(
    'data-variant-compare-price',
    comparePrice
  );

  currentPriceElement.textContent =
    formatRomixMoney(currentPrice);

  currentPriceElement.classList.toggle(
    'rpp-product-price__current--sale',
    hasDiscount
  );

  if (comparePriceElement) {
    if (hasDiscount) {
      comparePriceElement.textContent =
        formatRomixMoney(comparePrice);

      comparePriceElement.hidden = false;
      comparePriceElement.style.display = '';
    } else {
      comparePriceElement.textContent = '';
      comparePriceElement.hidden = true;
      comparePriceElement.style.display = 'none';
    }
  }

  if (discountBadge) {
    if (hasDiscount) {
      var discountPercentage = Math.round(
        (
          (comparePrice - currentPrice) /
          comparePrice
        ) * 100
      );

      discountBadge.textContent =
        '-' + discountPercentage + '%';

      discountBadge.hidden = false;
      discountBadge.style.display = '';
    } else {
      discountBadge.textContent = '';
      discountBadge.hidden = true;
      discountBadge.style.display = 'none';
    }
  }
}

/* ==========================================================
   ESTADO DEL BOTÓN DE COMPRA
========================================================== */

function updateAddToCartState(root, variant) {
  var addButton = root.querySelector(
    '.rpp-add-button'
  );

  if (!addButton || !variant) {
    return;
  }

  if (variant.available) {
    addButton.disabled = false;

    addButton.textContent =
      addButton.getAttribute(
        'data-rpp-add-text'
      ) || 'AÑADIR A LA CESTA';
  } else {
    addButton.disabled = true;

    addButton.textContent =
      addButton.getAttribute(
        'data-rpp-sold-out-text'
      ) || 'AGOTADO';
  }
}

/* ==========================================================
   CAMBIO DE IMAGEN SEGÚN LA VARIANTE
========================================================== */

function updateGalleryFromVariant(
  root,
  variant,
  selectedOptions
) {
  if (
    variant.featured_media &&
    variant.featured_media.id
  ) {
    var mediaThumbnail = root.querySelector(
      '[data-rpp-media-id="' +
        variant.featured_media.id +
        '"]'
    );

    if (mediaThumbnail) {
      setActiveGalleryImage(
        root,
        mediaThumbnail.getAttribute(
          'data-rpp-thumb'
        )
      );

      return;
    }
  }

  var selectedColor = selectedOptions.length
    ? String(selectedOptions[0])
        .trim()
        .toLowerCase()
    : '';

  if (!selectedColor) {
    return;
  }

  var matchingThumbnail = null;

  root
    .querySelectorAll('[data-rpp-thumb]')
    .forEach(function (thumbnail) {
      if (matchingThumbnail) {
        return;
      }

      var image = thumbnail.querySelector('img');

      if (!image) {
        return;
      }

      var imageAlt = String(
        image.getAttribute('alt') || ''
      ).toLowerCase();

      var imageSource = String(
        image.getAttribute('src') || ''
      ).toLowerCase();

      if (
        imageAlt.includes(selectedColor) ||
        imageSource.includes(selectedColor)
      ) {
        matchingThumbnail = thumbnail;
      }
    });

  if (matchingThumbnail) {
    setActiveGalleryImage(
      root,
      matchingThumbnail.getAttribute(
        'data-rpp-thumb'
      )
    );
  }
}/* ==========================================================
   GUÍA DE TALLAS
========================================================== */

function initRomixSizeGuide(root) {
  var sizeOpenButton = root.querySelector(
    '[data-rpp-open-size]'
  );

  var sizeModal = root.querySelector(
    '.rpp-size-modal'
  );

  var sizeOverlay = root.querySelector(
    '.rpp-size-overlay'
  );

  var sizeCloseButton = root.querySelector(
    '.rpp-size-close'
  );

  function openSizeGuide() {
    if (!sizeModal || !sizeOverlay) {
      return;
    }

    sizeModal.style.display = 'flex';
    sizeOverlay.style.display = 'block';

    document.body.classList.add(
      'rpp-modal-open'
    );
  }

  function closeSizeGuide() {
    if (!sizeModal || !sizeOverlay) {
      return;
    }

    sizeModal.style.display = 'none';
    sizeOverlay.style.display = 'none';

    document.body.classList.remove(
      'rpp-modal-open'
    );
  }

  closeSizeGuide();

  if (sizeOpenButton) {
    sizeOpenButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        openSizeGuide();
      }
    );
  }

  if (sizeCloseButton) {
    sizeCloseButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        closeSizeGuide();
      }
    );
  }

  if (sizeOverlay) {
    sizeOverlay.addEventListener(
      'click',
      closeSizeGuide
    );
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Escape') {
        closeSizeGuide();
      }
    }
  );
}
/* ==========================================================
   INICIALIZACIÓN DE LOS PACKS
========================================================== */

function initRomixBundles(root) {
  var bundleOptions = root.querySelectorAll(
    '[data-rpp-bundle-option], .rpp-bundle-option'
  );

  if (!bundleOptions.length) {
    return;
  }

  bundleOptions.forEach(function (option) {
    initialiseBundleOption(root, option);
  });

  bundleOptions.forEach(function (option) {
    option.addEventListener(
      'click',
      function (event) {
        var targetTagName = event.target.tagName
          ? event.target.tagName.toLowerCase()
          : '';

        if (
          targetTagName === 'select' ||
          targetTagName === 'option'
        ) {
          return;
        }

        var radioInput = option.querySelector(
          'input[type="radio"]'
        );

        if (radioInput) {
          radioInput.checked = true;

          radioInput.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }

        updateBundlePrice(root, option);
      }
    );

    option
      .querySelectorAll('select')
      .forEach(function (select) {
        select.addEventListener(
          'click',
          function (event) {
            event.stopPropagation();
          }
        );

        select.addEventListener(
          'change',
          function () {
            var radioInput =
              option.querySelector(
                'input[type="radio"]'
              );

            if (radioInput) {
              radioInput.checked = true;
            }

            updateBundlePrice(
              root,
              option
            );
          }
        );
      });

    var radioInput = option.querySelector(
      'input[type="radio"]'
    );

    if (radioInput) {
      radioInput.addEventListener(
        'change',
        function () {
          if (radioInput.checked) {
            updateBundlePrice(
              root,
              option
            );
          }
        }
      );
    }

    if (radioInput && radioInput.checked) {
      updateBundlePrice(root, option);
    }
  });
}

/* ==========================================================
   ACTUALIZACIÓN GENERAL DE LOS PACKS
========================================================== */

function refreshBundlePrices(root) {
  var bundleOptions = root.querySelectorAll(
    '[data-rpp-bundle-option], .rpp-bundle-option'
  );

  if (!bundleOptions.length) {
    return;
  }

  bundleOptions.forEach(function (option) {
    initialiseBundleOption(root, option);
  });

  var selectedOption =
    root.querySelector(
      '[data-rpp-bundle-option].is-open'
    ) ||
    root.querySelector(
      '.rpp-bundle-option.is-open'
    );

  if (!selectedOption) {
    var checkedRadio = root.querySelector(
      '.rpp-bundle-radio-native:checked'
    );

    selectedOption = checkedRadio
      ? checkedRadio.closest(
          '[data-rpp-bundle-option], .rpp-bundle-option'
        )
      : null;
  }

  if (!selectedOption) {
    selectedOption = root.querySelector(
      '[data-rpp-bundle-option], .rpp-bundle-option'
    );
  }

  if (selectedOption) {
    updateBundlePrice(
      root,
      selectedOption
    );
  }
}

/* ==========================================================
   PRECIO INTERNO DE CADA PACK
========================================================== */

function initialiseBundleOption(root, option) {
  var unitPrice = getRomixUnitPrice(root);
  var quantity = getBundleQuantity(option);

  var optionPrice = option.querySelector(
    '[data-rpp-option-price]'
  );

  var optionComparePrice = option.querySelector(
    '[data-rpp-option-compare]'
  );

  if (!unitPrice) {
    return;
  }

  var totals = calculateRomixBundleTotals(
    unitPrice,
    quantity,
    option
  );

  if (optionPrice) {
    optionPrice.textContent =
      formatRomixMoney(totals.discountedTotal);
  }

  if (optionComparePrice) {
    if (totals.hasBundleDiscount) {
      optionComparePrice.textContent =
        formatRomixMoney(totals.realTotal);

      optionComparePrice.hidden = false;
      optionComparePrice.style.display = '';
    } else {
      optionComparePrice.textContent = '';
      optionComparePrice.hidden = true;
      optionComparePrice.style.display = 'none';
    }
  }
}

/* ==========================================================
   PRECIO PRINCIPAL SEGÚN EL PACK SELECCIONADO
========================================================== */

function updateBundlePrice(root, option) {
  if (!root || !option) {
    return;
  }

  var priceWrapper = root.querySelector(
    '[data-rpp-product-price]'
  );

  var currentPriceElement = root.querySelector(
    '[data-rpp-current-price]'
  );

  var comparePriceElement = root.querySelector(
    '[data-rpp-compare-price]'
  );

  var discountBadge = root.querySelector(
    '[data-rpp-discount-badge]'
  );

  var savingText = root.querySelector(
    '[data-rpp-pack-saving]'
  );

  var quantityInput = root.querySelector(
    '[data-rpp-quantity]'
  );

  var bundleOptions = root.querySelectorAll(
    '[data-rpp-bundle-option], .rpp-bundle-option'
  );

  if (!priceWrapper || !currentPriceElement) {
    return;
  }

  var unitPrice = getRomixUnitPrice(root);
  var quantity = getBundleQuantity(option);

  if (!unitPrice) {
    return;
  }

  var totals = calculateRomixBundleTotals(
    unitPrice,
    quantity,
    option
  );

  var realTotal = totals.realTotal;
  var discountedTotal = totals.discountedTotal;
  var savedAmount = totals.savedAmount;
  var hasBundleDiscount = totals.hasBundleDiscount;

  if (quantityInput) {
    quantityInput.value = quantity;

    quantityInput.setAttribute(
      'value',
      quantity
    );
  }

  currentPriceElement.textContent =
    formatRomixMoney(discountedTotal);

  currentPriceElement.classList.toggle(
    'rpp-product-price__current--sale',
    hasBundleDiscount
  );

  bundleOptions.forEach(function (bundleOption) {
    bundleOption.classList.remove(
      'is-open'
    );
  });

  option.classList.add('is-open');

  var radioInput = option.querySelector(
    'input[type="radio"]'
  );

  if (radioInput) {
    radioInput.checked = true;
  }

  if (comparePriceElement) {
    if (hasBundleDiscount) {
      comparePriceElement.textContent =
        formatRomixMoney(realTotal);

      comparePriceElement.hidden = false;
      comparePriceElement.style.display = '';
    } else {
      var variantComparePrice = Number(
        priceWrapper.getAttribute(
          'data-variant-compare-price'
        ) || 0
      );

      var variantPrice = Number(
        priceWrapper.getAttribute(
          'data-variant-price'
        ) || unitPrice
      );

      if (
        variantComparePrice > variantPrice
      ) {
        comparePriceElement.textContent =
          formatRomixMoney(
            variantComparePrice
          );

        comparePriceElement.hidden = false;
        comparePriceElement.style.display = '';

        currentPriceElement.classList.add(
          'rpp-product-price__current--sale'
        );
      } else {
        comparePriceElement.textContent = '';
        comparePriceElement.hidden = true;
        comparePriceElement.style.display =
          'none';

        currentPriceElement.classList.remove(
          'rpp-product-price__current--sale'
        );
      }
    }
  }

  if (discountBadge) {
    if (hasBundleDiscount) {
      var discountPercentage = Math.round(
        (
          savedAmount /
          realTotal
        ) * 100
      );

      discountBadge.textContent =
        '-' + discountPercentage + '%';

      discountBadge.hidden = false;
      discountBadge.style.display = '';
    } else {
      var originalComparePrice = Number(
        priceWrapper.getAttribute(
          'data-variant-compare-price'
        ) || 0
      );

      var originalVariantPrice = Number(
        priceWrapper.getAttribute(
          'data-variant-price'
        ) || unitPrice
      );

      if (
        originalComparePrice >
        originalVariantPrice
      ) {
        var originalDiscountPercentage =
          Math.round(
            (
              (
                originalComparePrice -
                originalVariantPrice
              ) /
              originalComparePrice
            ) * 100
          );

        discountBadge.textContent =
          '-' +
          originalDiscountPercentage +
          '%';

        discountBadge.hidden = false;
        discountBadge.style.display = '';
      } else {
        discountBadge.textContent = '';
        discountBadge.hidden = true;
        discountBadge.style.display =
          'none';
      }
    }
  }

  if (savingText) {
    if (hasBundleDiscount) {
      savingText.textContent =
        'Ahorras ' +
        formatRomixMoney(savedAmount);

      savingText.hidden = false;
      savingText.style.display = '';
    } else {
      savingText.textContent = '';
      savingText.hidden = true;
      savingText.style.display = 'none';
    }
  }
}

/* ==========================================================
   PRECIO UNITARIO ACTUAL
========================================================== */

function getRomixUnitPrice(root) {
  var priceWrapper = root.querySelector(
    '[data-rpp-product-price]'
  );

  if (!priceWrapper) {
    return 0;
  }

  var variantPrice = parseInt(
    priceWrapper.getAttribute(
      'data-variant-price'
    ),
    10
  );

  if (variantPrice) {
    return variantPrice;
  }

  return (
    parseInt(
      priceWrapper.getAttribute(
        'data-unit-price'
      ),
      10
    ) || 0
  );
}

/* ==========================================================
   CANTIDAD Y UNIDADES PAGADAS DEL PACK
========================================================== */

function getBundleQuantity(option) {
  if (!option) {
    return 1;
  }

  return (
    parseInt(
      option.getAttribute(
        'data-rpp-qty'
      ),
      10
    ) || 1
  );
}

function getBundlePaidUnits(option) {
  if (!option) {
    return 1;
  }

  var paidUnits = parseInt(
    option.getAttribute(
      'data-rpp-paid'
    ),
    10
  );

  if (paidUnits) {
    return paidUnits;
  }

  return getBundleQuantity(option);
}

/* ==========================================================
   DESCUENTO PORCENTUAL Y TOTALES DEL PACK
========================================================== */

function getBundleDiscountPercentage(option) {
  if (!option) {
    return 0;
  }

  var attributeNames = [
    'data-rpp-discount',
    'data-rpp-discount-percent',
    'data-rpp-discount-percentage',
    'data-discount',
    'data-discount-percent'
  ];

  for (
    var index = 0;
    index < attributeNames.length;
    index++
  ) {
    var rawValue = option.getAttribute(
      attributeNames[index]
    );

    if (rawValue !== null && rawValue !== '') {
      var parsedValue = parseFloat(
        String(rawValue).replace(',', '.')
      );

      if (
        Number.isFinite(parsedValue) &&
        parsedValue > 0 &&
        parsedValue < 100
      ) {
        return parsedValue;
      }
    }
  }

  /*
    Compatibilidad con el Liquid actual:
    si el porcentaje aparece escrito en la tarjeta
    (por ejemplo, "15% descuento" o "20% descuento Extra"),
    se detecta automáticamente sin exigir cambios en el HTML.
  */
  var optionText = String(
    option.textContent || ''
  );

  var percentageMatch = optionText.match(
    /(\d+(?:[.,]\d+)?)\s*%/
  );

  if (percentageMatch) {
    var textPercentage = parseFloat(
      percentageMatch[1].replace(',', '.')
    );

    if (
      Number.isFinite(textPercentage) &&
      textPercentage > 0 &&
      textPercentage < 100
    ) {
      return textPercentage;
    }
  }

  return 0;
}

function calculateRomixBundleTotals(
  unitPrice,
  quantity,
  option
) {
  var safeUnitPrice = Math.max(
    0,
    Number(unitPrice) || 0
  );

  var safeQuantity = Math.max(
    1,
    parseInt(quantity, 10) || 1
  );

  var realTotal =
    safeUnitPrice * safeQuantity;

  var discountPercentage =
    getBundleDiscountPercentage(option);

  var discountedTotal = realTotal;

  if (discountPercentage > 0) {
    discountedTotal = Math.round(
      realTotal *
        (1 - discountPercentage / 100)
    );
  } else {
    /*
      Mantiene compatibilidad con packs antiguos
      configurados mediante data-rpp-paid.
    */
    var paidUnits =
      getBundlePaidUnits(option);

    if (
      paidUnits > 0 &&
      paidUnits < safeQuantity
    ) {
      discountedTotal =
        safeUnitPrice * paidUnits;

      discountPercentage =
        ((realTotal - discountedTotal) /
          realTotal) *
        100;
    }
  }

  discountedTotal = Math.max(
    0,
    Math.min(realTotal, discountedTotal)
  );

  var savedAmount = Math.max(
    0,
    realTotal - discountedTotal
  );

  return {
    realTotal: realTotal,
    discountedTotal: discountedTotal,
    savedAmount: savedAmount,
    discountPercentage:
      discountPercentage,
    hasBundleDiscount:
      savedAmount > 0
  };
}

/* ==========================================================
   FORMATO DE MONEDA
========================================================== */

function formatRomixMoney(cents) {
  var amount = Number(cents || 0);

  try {
    return (
      amount / 100
    ).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  } catch (error) {
    return (
      (amount / 100)
        .toFixed(2)
        .replace('.', ',') + ' €'
    );
  }
}
/* ==========================================================
   OBTENER EL PACK SELECCIONADO
========================================================== */

function getSelectedRomixBundle(root) {
  var selectedBundle =
    root.querySelector(
      '[data-rpp-bundle-option].is-open'
    ) ||
    root.querySelector(
      '.rpp-bundle-option.is-open'
    );

  if (!selectedBundle) {
    var checkedRadio = root.querySelector(
      '.rpp-bundle-radio-native:checked'
    );

    selectedBundle = checkedRadio
      ? checkedRadio.closest(
          '[data-rpp-bundle-option], .rpp-bundle-option'
        )
      : null;
  }

  if (!selectedBundle) {
    selectedBundle = root.querySelector(
      '[data-rpp-bundle-option], .rpp-bundle-option'
    );
  }

  return selectedBundle;
}
/* ==========================================================
   OPCIONES SELECCIONADAS EN CADA UNIDAD DEL PACK
========================================================== */

function getRomixOptionsFromUnit(unit) {
  var selectedOptions = [];

  if (!unit) {
    return selectedOptions;
  }

  unit
    .querySelectorAll('[data-rpp-pack-option]')
    .forEach(function (select) {
      var optionPosition = parseInt(
        select.getAttribute(
          'data-rpp-option-position'
        ),
        10
      );

      if (
        optionPosition &&
        select.value
      ) {
        selectedOptions[
          optionPosition - 1
        ] = select.value;
      }
    });

  return selectedOptions.filter(
    function (value) {
      return (
        value !== undefined &&
        value !== null &&
        value !== ''
      );
    }
  );
}

/* ==========================================================
   CONSTRUIR LOS ARTÍCULOS DEL PACK PARA EL CARRITO
========================================================== */

function buildRomixCartItemsFromBundle(
  root,
  selectedBundle
) {
  var items = [];

  if (!root || !selectedBundle) {
    return items;
  }

  var bundleUnits =
    selectedBundle.querySelectorAll(
      '[data-rpp-bundle-unit]'
    );

  bundleUnits.forEach(function (unit) {
    var selectedOptions =
      getRomixOptionsFromUnit(unit);

    if (!selectedOptions.length) {
      selectedOptions =
        getRomixSelectedOptions(root);
    }

    var selectedVariant =
      findRomixVariant(
        root,
        selectedOptions
      );

    if (
      selectedVariant &&
      selectedVariant.available !== false
    ) {
      items.push({
        id: selectedVariant.id,
        quantity: 1
      });
    }
  });

  /*
    Si el pack no tiene selectores internos,
    utiliza la variante superior seleccionada
    y la cantidad configurada en el pack.
  */
  if (!items.length) {
    var fallbackOptions =
      getRomixSelectedOptions(root);

    var fallbackVariant =
      findRomixVariant(
        root,
        fallbackOptions
      );

    var fallbackQuantity =
      getBundleQuantity(selectedBundle);

    if (
      fallbackVariant &&
      fallbackVariant.available !== false
    ) {
      for (
        var index = 0;
        index < fallbackQuantity;
        index++
      ) {
        items.push({
          id: fallbackVariant.id,
          quantity: 1
        });
      }
    }
  }

  return items;
}

/* ==========================================================
   VALIDAR QUE TODAS LAS UNIDADES DEL PACK SON CORRECTAS
========================================================== */

function validateRomixBundleItems(
  root,
  selectedBundle,
  items
) {
  if (!selectedBundle) {
    return {
      valid: false,
      message:
        'No se encontró el pack seleccionado.'
    };
  }

  if (!items || !items.length) {
    return {
      valid: false,
      message:
        'No se encontró ninguna variante válida.'
    };
  }

  var expectedQuantity =
    getBundleQuantity(selectedBundle);

  if (items.length !== expectedQuantity) {
    return {
      valid: false,
      message:
        'Selecciona correctamente el color y la talla de todas las unidades.'
    };
  }

  return {
    valid: true,
    message: ''
  };
}

/* ==========================================================
   CONTADOR DEL CARRITO
========================================================== */

function updateRomixCartBubble(itemCount) {
  var cartBubble = document.querySelector(
    '#cart-icon-bubble'
  );

  if (!cartBubble) {
    return;
  }

  var countBubble =
    cartBubble.querySelector(
      '.cart-count-bubble'
    );

  if (itemCount <= 0) {
    if (countBubble) {
      countBubble.remove();
    }

    return;
  }

  if (!countBubble) {
    countBubble =
      document.createElement('div');

    countBubble.className =
      'cart-count-bubble';

    countBubble.innerHTML =
      '<span aria-hidden="true"></span>' +
      '<span class="visually-hidden"></span>';

    cartBubble.appendChild(
      countBubble
    );
  }

  var visibleCount =
    countBubble.querySelector(
      'span[aria-hidden="true"]'
    );

  var accessibleCount =
    countBubble.querySelector(
      '.visually-hidden'
    );

  if (visibleCount) {
    visibleCount.textContent =
      itemCount < 100
        ? itemCount
        : '99+';
  }

  if (accessibleCount) {
    accessibleCount.textContent =
      itemCount +
      ' artículos en el carrito';
  }
}

/* ==========================================================
   ACTUALIZAR Y ABRIR EL CARRITO LATERAL
========================================================== */

function refreshAndOpenRomixCart() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'X-Requested-With':
        'XMLHttpRequest'
    }
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          'No se pudo actualizar el carrito.'
        );
      }

      return response.json();
    })
    .then(function (cart) {
      updateRomixCartBubble(
        cart.item_count || 0
      );

      document.documentElement.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true,
            detail: {
              cart: cart
            }
          }
        )
      );

      document.documentElement.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            bubbles: true,
            detail: {
              cart: cart
            }
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true,
            detail: {
              cart: cart
            }
          }
        )
      );

      var cartDrawer =
        document.querySelector(
          'cart-drawer'
        );

      if (cartDrawer) {
        cartDrawer.classList.remove(
          'is-empty'
        );

        if (
          typeof cartDrawer.renderContents ===
          'function'
        ) {
          /*
            Algunos temas Dawn actualizan el drawer
            con la respuesta de /cart/add.js.
            Si no acepta este contenido, los eventos
            superiores permiten que el tema lo refresque.
          */
        }

        if (
          typeof cartDrawer.open ===
          'function'
        ) {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add(
            'active'
          );

          document.body.classList.add(
            'overflow-hidden'
          );
        }

        return cart;
      }

      var cartNotification =
        document.querySelector(
          'cart-notification'
        );

      if (
        cartNotification &&
        typeof cartNotification.open ===
          'function'
      ) {
        cartNotification.open();

        return cart;
      }

      var cartIconBubble =
        document.querySelector(
          '#cart-icon-bubble'
        );

      if (cartIconBubble) {
        cartIconBubble.click();
      }

      return cart;
    });
}

/* ==========================================================
   AÑADIR PACK AL CARRITO MEDIANTE AJAX
========================================================== */

function initRomixAjaxCart(root) {
  var addButton = root.querySelector(
    '[data-rpp-direct-add], .rpp-add-button'
  );

  if (!addButton) {
    return;
  }

  addButton.addEventListener(
    'click',
    function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (addButton.disabled) {
        return;
      }

      var originalButtonText =
        addButton.textContent;

      var selectedBundle =
        getSelectedRomixBundle(root);

      var items =
        buildRomixCartItemsFromBundle(
          root,
          selectedBundle
        );

      var validation =
        validateRomixBundleItems(
          root,
          selectedBundle,
          items
        );

      if (!validation.valid) {
        alert(validation.message);
        return;
      }

      addButton.disabled = true;
      addButton.textContent =
        'AÑADIENDO...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/json',
          Accept:
            'application/json',
          'X-Requested-With':
            'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (
                errorData
              ) {
                var errorMessage =
                  errorData.description ||
                  errorData.message ||
                  'No se pudo añadir el producto al carrito.';

                throw new Error(
                  errorMessage
                );
              });
          }

          return response.json();
        })
        .then(function () {
          return refreshAndOpenRomixCart();
        })
        .then(function () {
          addButton.textContent =
            'AÑADIDO ✓';
        })
        .catch(function (error) {
          console.error(
            'Romix Ajax Cart error:',
            error
          );

          alert(
            error.message ||
            'Ha ocurrido un error al añadir el producto al carrito.'
          );

          addButton.textContent =
            originalButtonText;
        })
        .finally(function () {
          window.setTimeout(
            function () {
              var selectedOptions =
                getRomixSelectedOptions(
                  root
                );

              var currentVariant =
                findRomixVariant(
                  root,
                  selectedOptions
                );

              if (
                currentVariant &&
                currentVariant.available
              ) {
                addButton.disabled =
                  false;

                addButton.textContent =
                  addButton.getAttribute(
                    'data-rpp-add-text'
                  ) ||
                  originalButtonText ||
                  'AÑADIR A LA CESTA';
              } else {
                addButton.disabled =
                  true;

                addButton.textContent =
                  addButton.getAttribute(
                    'data-rpp-sold-out-text'
                  ) ||
                  'AGOTADO';
              }
            },
            1200
          );
        });
    }
  );
}

/* ==========================================================
   INICIALIZACIÓN DEL ARCHIVO
========================================================== */

function initialiseRomixAfterPageLoad() {
  initRomixProductPro();
}

if (
  document.readyState === 'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    initialiseRomixAfterPageLoad
  );
} else {
  initialiseRomixAfterPageLoad();
}

document.addEventListener(
  'shopify:section:load',
  function () {
    initRomixProductPro();
  }
);

document.addEventListener(
  'shopify:section:reorder',
  function () {
    initRomixProductPro();
  }
);

document.addEventListener(
  'shopify:block:select',
  function () {
    initRomixProductPro();
  }
);